export default __webpack_public_path__ + "static/media/download-icon.faa9a321.svg";